import { FunctionComponent, useContext, useState } from "react";
import { IOrderDeliveryTask } from "../../../interfaces/delivery-company/tasks";
import { DialogTitle, Typography, DialogContent, Alert, DialogActions, Button, CircularProgress } from "@mui/material";
import CustomDialog from "../custom-dialog/custom-dialog";
import MoneyInput from "../money-input/money-input";
import { useSnackBar } from "../../../contexts/snackbar";
import { AuthContext } from "../../../contexts/user-context/user-context";
import { OrderDeliveryTaskState } from "../../../enums/tasks";
import { Money } from "../../../utils/money";
import { API_ENDPOINT } from "../../../configurations/global.config";
import axios from "axios";

interface UpdateCommissionDialogProps {
    task: IOrderDeliveryTask
    updateDeliveryTaskCommission: (m: Money[]) => void
    onClose: ()=>void
}
 
const UpdateCommissionDialog: FunctionComponent<UpdateCommissionDialogProps> = ({task, onClose, updateDeliveryTaskCommission}) => {
    const failed = task.status ==  OrderDeliveryTaskState.FAILED
    
    const commission = failed ? task.failed_delivery_commission : task.driver_commission
    const [money, setMoney] = useState<Money[]>(commission)
    const [isSaving, setIsSaving] = useState(false)
    const { showMessage } = useSnackBar()
    const {config} = useContext(AuthContext)
    
    const handleSave = async () => {
        setIsSaving(true)
        try {
            const endpoint = `${API_ENDPOINT}/v1/delivery-task/${task.id}/`
            const data = failed ? {
                failed_delivery_commission: money,
            } : {
                driver_commission: money
            }

            await axios.patch(endpoint, data, config)
            showMessage("Updated commission!")
            updateDeliveryTaskCommission(money) 
            onClose()
        } catch(e) {
            showMessage("Operation Failed", 'error')
        } finally {
            setIsSaving(false)
        }
    }
    
    return <CustomDialog open={true} onClose={onClose} maxWidth='sm' fullWidth>
                <DialogTitle>
                    <Typography align={"center"} variant="h5">
                        Change Driver Commission
                    </Typography>
                    
                </DialogTitle>

                <DialogContent>
                    <Alert severity="info">This amount will be paid in case of <b><u>{failed ? "failure" : "success"}</u></b> of the delivery task.</Alert>
                    <br />
                    <MoneyInput money={money} setMoney={setMoney} label={"Commission"} />
                </DialogContent>

                <DialogActions>

                    <Button disabled={isSaving} onClick={handleSave}>Save {isSaving && <CircularProgress sx={{ml: 2}} size={20}/>}</Button>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </CustomDialog>;
}
 
export default UpdateCommissionDialog;